var map = {
	"./en-AU": 32075,
	"./en-AU.js": 32075,
	"./en-CA": 12297,
	"./en-CA.js": 12297,
	"./en-GB": 92484,
	"./en-GB.js": 92484,
	"./en-US": 32997,
	"./en-US.js": 32997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37032;